export enum ProviderTypes {
  COMPANY = 1,
  BOINSTITUTION = 2,
  SCHOOL = 3
}
